import React, { useEffect, useRef, useState } from "react";
import styles from "./MembershipDealsModal.module.css";
import styles1 from "../AuthForm/AuthForm.module.css";
import unlock_icon from "../../../assets/svg/unlock_modal_icon.svg";
import gift_box from "../../../assets/svg/memberdeal_giftbox.svg";
import close_icon from "../../../assets/svg/membershipdeal_close.svg";
import lock_icon from "../../../assets/svg/unlock_svg.svg";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import storageService from "../../../Services/storageService";
import {
  bookingTokenApi,
  otpCreateLoginAccount,
  verifyOtpCreateLoginAccount,
  otpLoginAccount,
  verifyOtpLoginAccount,
} from "../../../Services/mainPageService";
import { isValidTimeZone } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { fetchPromotions } from "../../../redux/actions/hotelInfoAction";
import toastr, { error } from "toastr";
import hotelInfoTypes from "../../../redux/actionType/hotelInfoTypes";

const MembershipDealsModal = ({
  isOpen,
  onClose,
  isUnlocked,
  getSecretMemberDealUrl,
  applyPromotion,
}) => {
  // const [isSignup, setIsSignup] = useState(false);
  const [usePhoneLogin, setUsePhoneLogin] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: "",
    otp: "",
    emailOtp: "",
    phoneOtp: "",
  });
  const [phone, setPhone] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpResponse, setOtpResponse] = useState("");
  // const [isVerified, setIsVerified] = useState(false);
  const isVerified = useRef();
  const [loading, isLoading] = useState(false);
  const { hotelData, dateRange, isSignup } = useSelector(
    (state) => state.hotelInfo
  );
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleGetSignupOtp = async () => {
    isLoading(true);

    let dialCode = "";
    let mobile = "";

    if (phone) {
      try {
        const parsedPhone = parsePhoneNumber(String(phone));
        dialCode = `+${parsedPhone.countryCallingCode}`;
        mobile = parsedPhone.nationalNumber;
      } catch (error) {
        toastr.error("Invalid phone number format");
        isLoading(false);
        return;
      }
    }

    if (!formData?.email && !phone) {
      toastr.error("Please enter details");
      isLoading(false);
      return;
    }

    if (formData?.email) {
      const emailArray = formData.email.split(",").map((email) => email.trim());
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailArray.every((email) => emailRegex.test(email))) {
        toastr.error("Please enter valid email addresses");
        isLoading(false);
        return;
      }
    }

    try {
      const reqObj = {
        name: formData?.name,
        dialCode: dialCode,
        mobile: mobile,
        email: formData?.email,
      };

      console.log("obj", reqObj);

      const response = await otpCreateLoginAccount(reqObj);

      if (response.status === 200) {
        toastr.success("OTP sent successfully");
        setOtpResponse(response.data);
        setOtpSent(true);
      } else {
        toastr.error("Please try again later");
      }
    } catch (error) {
      console.log("error", error);
      toastr.error("An error occurred. Please try again later.");
    } finally {
      isLoading(false);
    }
  };
  const handleVerifySignupOtp = async () => {
    isLoading(true);
    const obj = {
      sessionId: otpResponse?.data?.sessionId,
      email: otpResponse?.data?.email,
      mobile: otpResponse?.data?.mobile,
      mobileOtp: formData?.mobileOtp,
      emailOtp: formData?.emailOtp,
      dialCode: otpResponse?.data?.dialCode,
    };

    try {
      const response = await verifyOtpLoginAccount(obj);
      if (response.status === 200) {
        toastr.succcess("login succesful");
        isVerified.current = true;
      } else {
        toastr.error("Invalid Phone OTP. Please try again.");
        return;
      }
    } catch {
      console.log("err", error);
    } finally {
      isLoading(false);
    }
  };

  const handleGetOtp = async () => {
    isLoading(true);

    let dialCode = "";
    let mobile = "";

    if (phone) {
      try {
        const parsedPhone = parsePhoneNumber(String(phone));
        dialCode = `+${parsedPhone.countryCallingCode}`;
        mobile = parsedPhone.nationalNumber;
      } catch (error) {
        toastr.error("Invalid phone number format");
        isLoading(false);
        return;
      }
    }

    if (!formData?.email && !phone) {
      toastr.error("Please enter details");
      isLoading(false);
      return;
    }

    if (formData?.email) {
      const emailArray = formData.email.split(",").map((email) => email.trim());
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailArray.every((email) => emailRegex.test(email))) {
        toastr.error("Please enter valid email addresses");
        isLoading(false);
        return;
      }
    }

    try {
      const reqObj = {
        dialCode,
        mobile,
        email: formData?.email,
      };

      console.log("obj", reqObj);

      const response = await otpLoginAccount(reqObj);

      if (response.status === 200) {
        toastr.success("OTP sent successfully");
        setOtpResponse(response.data);
        setOtpSent(true);
      } else {
        toastr.error("Please try again later");
      }
    } catch (error) {
      console.log("error", error);
      toastr.error("An error occurred. Please try again later.");
    } finally {
      isLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    isLoading(true);
    const obj = {
      sessionId: otpResponse?.data?.sessionId,
      email: otpResponse?.data?.email,
      mobile: otpResponse?.data?.mobile,
      otp: formData?.emailOtp || formData?.phoneOtp,
      dialCode: otpResponse?.data?.dialCode,
    };

    try {
      const response = await verifyOtpLoginAccount(obj);
      if (response.status === 200) {
        toastr.succcess("login succesful");
        isVerified.current = true;
      } else {
        toastr.error("Invalid Phone OTP. Please try again.");
        return;
      }
    } catch {
      console.log("err", error);
    } finally {
      isLoading(false);
    }
  };

  const [defaultCountry, setDefaultCountry] = useState("IN");
  // const { id } = hotelData;

  // const getPromotions = async () => {
  //   const url = getSecretMemberDealUrl();
  //   // dispatch(fetchPromotions(url, id));
  //   applyPromotion();
  // };

  const handleSubmit1 = async (e) => {
    console.log("Called?");
    e.preventDefault();

    if (isSignup && !otpSent) {
      await handleGetSignupOtp();
      return;
    }
    if (isSignup && otpSent && !isVerified?.current) {
      await handleVerifySignupOtp();
      if (!isVerified?.current) {
        toastr.error("OTP verification failed");
        return;
      }
    }
    if (!isSignup && !otpSent) {
      await handleGetOtp();
      return;
    }
    if (!isSignup && otpSent && !isVerified?.current) {
      await handleVerifyOtp();
      if (!isVerified?.current) {
        toastr.error("OTP verification failed");
        return;
      }
    }

    console.log("Form submitted:", formData);
    const phoneNumber = parsePhoneNumber(String(phone));
    const dialCode = phoneNumber ? `+${phoneNumber.countryCallingCode}` : "";
    const mobile = phoneNumber ? phoneNumber.nationalNumber : "";

    if (isVerified?.current) {
      console.log("obj", formData);

      await bookingTokenApi({
        email: formData?.email,
        gender: "",
        name: formData?.name,
        receiveEmails: formData?.receiveEmails,
        mobile: formData?.mobile,
        dialCode: formData?.dialCode,
        dob: "",
        regMedium: "membership_deals",
      });
      sessionStorage.setItem("isMembershipUnlocked", "true");
      applyPromotion();
      onClose();
    }
  };

  const handleGetOtpCommon = async (isSignup) => {
    isLoading(true);

    let dialCode = "";
    let mobile = "";

    if (phone) {
      try {
        const parsedPhone = parsePhoneNumber(String(phone));
        dialCode = `+${parsedPhone.countryCallingCode}`;
        mobile = parsedPhone.nationalNumber;
      } catch (error) {
        toastr.error("Invalid phone number format");
        isLoading(false);
        return;
      }
    }

    if (!formData?.email && !phone) {
      toastr.error("Please enter details");
      isLoading(false);
      return;
    }

    if (formData?.email) {
      const emailArray = formData.email.split(",").map((email) => email.trim());
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!emailArray.every((email) => emailRegex.test(email))) {
        toastr.error("Please enter valid email addresses");
        isLoading(false);
        return;
      }
    }

    try {
      const reqObj = {
        name: isSignup ? formData?.name : undefined, // Name only for signup
        dialCode,
        mobile,
        email: formData?.email,
      };

      console.log("Requesting OTP:", reqObj);

      const response = isSignup
        ? await otpCreateLoginAccount(reqObj)
        : await otpLoginAccount(reqObj);

      if (response.status === 200) {
        toastr.success("OTP sent successfully");
        setOtpResponse(response);
        setOtpSent(true);
      } else {
        toastr.error("Please try again later");
      }
    } catch (error) {
      console.error("OTP Request Error:", error);
      toastr.error("An error occurred. Please try again later.");
    } finally {
      isLoading(false);
    }
  };

  const handleVerifyOtpCommon = async (isSignup) => {
    isLoading(true);
    console.log("otpresp", otpResponse);
    // Common request fields for both Signup & Login
    const reqObj = {
      sessionId: otpResponse?.data?.sessionId,
      email: otpResponse?.data?.email,
      mobile: otpResponse?.data?.mobile,
      dialCode: otpResponse?.data?.dialCode,
    };

    // Modify OTP fields based on whether it's Signup or Login
    if (isSignup) {
      // reqObj.mobileOtp = formData.phoneOtp;
      reqObj.emailOtp = formData.emailOtp;
    } else {
      reqObj.otp = usePhoneLogin ? formData.phoneOtp : formData.emailOtp;
    }
    console.log("obj", reqObj);
    try {
      const response = isSignup
        ? await verifyOtpCreateLoginAccount(reqObj) // API for signup OTP verification
        : await verifyOtpLoginAccount(reqObj); // API for login OTP verification

      if (response.status === 200) {
        toastr.success("OTP verification successful");
        isVerified.current = true;
        sessionStorage.setItem(
          "userName",
          response?.data?.user?.firstName || formData?.name
        );
      } else {
        toastr.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("OTP Verification Error:", error);
      toastr.error("An error occurred. Please try again.");
    } finally {
      isLoading(false);
    }
  };

  const handleSubmit = async (e, isResend = false) => {
    e.preventDefault();

    if (!otpSent || isResend) {
      await handleGetOtpCommon(isSignup);
      return;
    }

    if (!isVerified?.current) {
      await handleVerifyOtpCommon(isSignup);
      if (!isVerified?.current) {
        toastr.error("OTP verification failed");
        return;
      }
    }

    console.log("Form submitted:", formData);

    const phoneNumber = parsePhoneNumber(String(phone));
    const dialCode = phoneNumber ? `+${phoneNumber.countryCallingCode}` : "";
    const mobile = phoneNumber ? phoneNumber.nationalNumber : "";

    if (isVerified?.current) {
      if (isSignup) {
        await bookingTokenApi({
          email: formData?.email,
          gender: "",
          name: formData?.name,
          receiveEmails: formData?.receiveEmails,
          mobile,
          dialCode,
          dob: "",
          regMedium: "membership_deals",
        });
      }

      await applyPromotion();
      sessionStorage.setItem("isMembershipUnlocked", "true");
      onClose();
    }
  };

  useEffect(() => {
    setUsePhoneLogin(false);
    setOtpSent(false);
    isVerified.current = false;
    setFormData({
      email: "",
      name: "",
      phone: "",
      otp: "",
      emailOtp: "",
      phoneOtp: "",
      receiveEmails: false,
    });
    setPhone("");
    setOtpResponse("");
  }, [isSignup]);

  useEffect(() => {
    let country = storageService.get("searchParams") || {};
    let locx = storageService.get("locationDetails") || {};
    if (country?.country) {
      setDefaultCountry(country?.country);
    } else if (locx?.country) {
      setDefaultCountry(locx?.country);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose}>
          <img src={close_icon} alt="" />
        </button>

        <div className={styles.contentLayout}>
          <div className={styles.imageContainer}>
            <img
              src={gift_box}
              alt="Gift box with blue ribbon"
              className={styles.giftImage}
            />
          </div>

          <form onSubmit={handleSubmit} className={styles1.form}>
            {(hotelData?.chainName === "zinc" ||
              hotelData?.chainName === "beacon") && (
              <div className={styles1.modalHeader}>
                <div className={styles1.giftIconContainer}>
                  <img src={unlock_icon} alt="" />
                </div>
                <h2 className={styles1.btrue}>B-connect true value</h2>
              </div>
            )}
            <h2 className={styles1.title}>
              {isSignup
                ? "Sign up and get exclusive rates & discounts"
                : "Login to Your Account"}
            </h2>
            <p className={styles1.subtitle}>
              {isSignup
                ? "Create an account to get started"
                : "Welcome back, please enter your details"}
            </p>

            {isSignup && !otpSent && (
              <input
                type="text"
                name="name"
                placeholder="Your Name*"
                value={formData.name}
                onChange={handleChange}
                className={styles1.input}
                required
                disabled={otpSent}
              />
            )}

            {!usePhoneLogin && !otpSent && (
              <input
                type="email"
                name="email"
                placeholder="Email Address*"
                value={formData.email}
                onChange={handleChange}
                className={styles1.input}
                required
                disabled={otpSent}
              />
            )}

            {(isSignup || usePhoneLogin) && !otpSent && (
              <PhoneInput
                className={styles1.input}
                placeholder="Phone Number"
                name="phone"
                value={phone}
                defaultCountry={defaultCountry}
                onChange={setPhone}
                disabled={otpSent}
              />
            )}

            {!otpSent && (
              <button type="submit" className={styles1.submitButton}>
                Get OTP
              </button>
            )}

            {otpSent && (
              <>
                {isSignup && (
                  <>
                    <input
                      type="text"
                      name="emailOtp"
                      placeholder="Enter Email OTP"
                      value={formData.emailOtp}
                      onChange={handleChange}
                      className={styles1.input}
                      required
                    />
                    {/* <input
                      type="text"
                      name="phoneOtp"
                      placeholder="Enter Phone OTP"
                      value={formData.phoneOtp}
                      onChange={handleChange}
                      className={styles1.input}
                      required
                    /> */}
                  </>
                )}
                {!isSignup && (
                  <input
                    type="text"
                    name={usePhoneLogin ? "phoneOtp" : "emailOtp"}
                    placeholder="Enter OTP"
                    value={
                      usePhoneLogin ? formData.phoneOtp : formData.emailOtp
                    }
                    onChange={handleChange}
                    className={styles1.input}
                    required
                  />
                )}
                {otpSent && (
                  <p className={styles1.switchText1}>
                    Didn't get an OTP?{" "}
                    <button
                      type="button"
                      onClick={(e) => handleSubmit(e, true)}
                      className={styles1.link}
                      style={{ background: "none" }}
                    >
                      Resend
                    </button>
                  </p>
                )}
                <button type="submit" className={styles1.submitButton}>
                  Verify OTP
                </button>
              </>
            )}

            {/* {!isSignup && (
              <p className={styles1.switchText}>
                {usePhoneLogin ? "Login with Email?" : "Login with Phone?"}
                <span
                  onClick={() => setUsePhoneLogin(!usePhoneLogin)}
                  className={styles1.linkText}
                >
                  {usePhoneLogin ? "Use Email" : "Use Phone"}
                </span>
              </p>
            )} */}

            <p className={styles1.switchText}>
              {isSignup ? "Already have an account?" : "Don't have an account?"}
              <span
                //  onClick={() => {
                //   setIsSignup(!isSignup);
                // }}
                onClick={() =>
                  dispatch({
                    type: hotelInfoTypes.SET_SIGN_UP,
                    payload: !isSignup,
                  })
                }
                className={styles1.link}
              >
                {isSignup ? "Login" : "Sign Up"}
              </span>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MembershipDealsModal;
